module.exports = __webpack_public_path__ + "static/media/phone5.b194e93b.png";